<template>
  <div class="padding-zero">
    <loader v-if="loading" />
    <div v-else>
      <user-process-nav :current="myType" />
      <user-process-wrapper
        v-if="!loading"
        @process-chosen="showDetailedWindow"
        @refresh="fetchCurrentUserProcesses"
        @refresh-with-alert="refreshViewWithAlert"
        :title="showCorrectTitle(myType)"
      />
      <user-process-detailed-modal
        @close-modal="showDetails = false"
        @refresh="refreshView"
        v-if="showDetails"
        :data="currentProcess"
      ></user-process-detailed-modal>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import { pl } from "vuejs-datepicker/dist/locale";
import { tasksNavigationOptions } from "@/utils/options.js";
import UserProcessWrapper from "../../components/UserProcessWrapper.vue";
import UserProcessNav from "../../components/UserProcessNav.vue";
import UserProcessDetailedModal from "@/components/UserProcessDetailedModal";
export default {
  components: { Loader, UserProcessWrapper, UserProcessNav, UserProcessDetailedModal },
  name: "UserProcessPaymentView",
  //: { ManagementPanel, Pagination },
  data() {
    return {
      pl: pl,
      tasksNavigationOptions: tasksNavigationOptions,
      loading: false,
      myType: this.$router.currentRoute.query.type,
      settings: this.allSettings,
      showDetails: false,
    };
  },

  async mounted() {
    this.loading = true;
    try {
      await this.$store.dispatch("fetchProcesTypes");
      await this.$store.dispatch("fetchProcesSettings");
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },
  watch: {
    allSettings() {
      this.fetchCurrentUserProcesses();
    },
    $route() {
      if (this.myType !== this.$router.currentRoute.query.type) {
        this.myType = this.$router.currentRoute.query.type;
        this.fetchCurrentUserProcesses();
      }
    },
  },
  methods: {
    async refreshViewWithAlert() {
      await this.refreshView();
      this.$notify({
        group: "success",
        text: "Pomyślnie odświeżono dane",
      });
    },
    async refreshView() {
      this.loading = true;
      try {
        await this.$store.dispatch("fetchProcesTypes");
        await this.$store.dispatch("fetchProcesSettings");
        await this.fetchCurrentUserProcesses();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async showDetailedWindow(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("setUserToNull");

        await this.$store.dispatch("fetchOneProcess", id);
        await this.$store.dispatch("getUserById", {
          userId: this.currentProcess.user_id,
        });
        this.showDetails = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    redirectToUserProcess(process) {
      if (process === "TASKS") this.$router.push({ name: "Tasks" });
      if (process === this.myType) this.$router.push({ name: "UserProcess" });
    },
    async fetchCurrentUserProcesses() {
      const queries = this.$router.currentRoute.query;
      let filterBy = "";
      let filterWith = "";
      let filterBySecond = "";
      let filterWithSecond = "";
      let search = "";
      if (queries.search) search = queries.search;
      if (queries.filterBy) filterBy = queries.filterBy;
      if (queries.filterWith) filterWith = queries.filterWith;
      if (queries.filterBySecond) filterBySecond = queries.filterBySecond;
      if (queries.filterWithSecond) filterWithSecond = queries.filterWithSecond;

      if (this.allSettings && this.allSettings.statuses) {
        this.allSettings.statuses.forEach(async (status) => {
          await this.$store.dispatch("fetchProcesses", {
            status: status,
            type: this.myType,
            filterBy: filterBy,
            filterWith: filterWith,
            filterBySecond: filterBySecond,
            filterWithSecond: filterWithSecond,
            search: search,
          });
        });
      }
      this.loading = false;
      // this.showDetails = false;
    },
    showCorrectTitle(title) {
      if (title === "INITIALIZED_ORDER") return "Zainicjowani";
      if (title === "WITHOUT_VERIFICATION_PAYMENT")
        return "Niedokończona/nierozpoczęta płatność";
      if (title === "REJECTED_BY_ADMIN") return "Odrzucone przez admina";
      if (title === "CUSTOMER_SUCCESS") return "Customer Success";
      return title;
    },
  },

  computed: {
    currentProcess() {
      return this.$store.getters.getCurrentProcess;
    },
    processTypes() {
      return this.$store.getters.getProcessTypes;
    },
    allProcesses() {
      return this.$store.getters.getProcesses;
    },
    allSettings() {
      return this.$store.getters.getProcessSettings;
    },
  },
};
</script>

<style scoped></style>
